import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import React, { Suspense } from "react";
import { CircularProgress, Typography } from "@mui/material";
import { Error } from "./pages/errors/404";


import { CssBaseline } from "@mui/material";
import { SpecialLayout } from "./layouts/SpecialLayout";

export function App() {
  return (
    <BrowserRouter>
      <CssBaseline />
      <Suspense
        fallback={
          <div className="loader-wrapper">
            <CircularProgress color="primary" size={70} />
            <Typography variant="body1" className="loader-text">
              {" "}
              Loading..
            </Typography>
          </div>
        }
      >
        <Routes>
          <Route path="/*" element={<SpecialLayout />} />
          <Route path="/*" element={<Error />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
